export default "__VITE_ASSET__WRWhvnIJ__"